import { LocalEvent } from "../Actions/LocalEvent";
import { ServerEvent } from "../Actions/ServerEvent";
import { BaseStore } from "../BaseStore";

interface IOperationMethod { (request: LocalEvent, store: BaseStore): void; }

interface IServerOperationMethod { (request: ServerEvent, store: BaseStore): void; }

class OperationMethodItem {
    public method: IOperationMethod;
    public operation: number;
    public autoEmit: boolean;
    public static Create(operation: number, fn: IOperationMethod, emitChange: boolean): OperationMethodItem {
        var m = new OperationMethodItem();
        m.method = fn;
        m.operation = operation;
        m.autoEmit = emitChange;
        return m;
    }
}
class ServerOperationMethodItem {
    public method: IServerOperationMethod;
    public operation: number;
    public suboperation: number;
    public autoEmit: boolean;
    public isGlobal: boolean;

    public static Create(operation: number, subOperation: number, fn: IServerOperationMethod, emitChange: boolean): ServerOperationMethodItem {
        var m = new ServerOperationMethodItem();
        m.method = fn;
        m.operation = operation;
        m.suboperation = subOperation;
        m.autoEmit = emitChange;
        return m;
    }
}

export { IOperationMethod, IServerOperationMethod, OperationMethodItem, ServerOperationMethodItem };
